import { render } from "./alipay.vue?vue&type=template&id=77e7e9c8"
import script from "./alipay.vue?vue&type=script&lang=js"
export * from "./alipay.vue?vue&type=script&lang=js"

import exportComponent from "/Users/demigodliu/src/packages/cumen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__